var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"index",staticClass:"group",class:{'selected': _vm.isSelected},on:{"click":function($event){return _vm.selectGroup()}}},[_c('ui-badge',{attrs:{"abbreviation":_vm.data.name,"color":_vm.data.color,"design":"xs"}}),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.data.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }